import React, { Component } from 'react';
import { options } from './keys';
import { flattenChildren, getParents } from './helpers';

class TopMenu extends Component {
    constructor(props) {
        super();

        this.domainId = props.domain_id || props.default_domain_id;
        this.options = options({ domainId: this.domainId, hasCommerce: props.has_commerce });
        this.state = {
            selectedIds: [],
            defaultSelected: [],
        };
    }

    componentDidMount() {
        const all = flattenChildren(this.options);
        const selectedItem = all.find((item) => {
            if (item.hrefStartsWith)
                return window.location?.pathname.startsWith(item.hrefStartsWith);

            if (item.pathnames) return item.pathnames.includes(window.location?.pathname);

            return item.href === window.location?.pathname;
        });
        const parents = getParents(all, selectedItem);
        const reversed = parents.reverse();

        if (selectedItem)
            this.setState({
                selectedIds: [...reversed, selectedItem.id],
                defaultSelected: [...reversed, selectedItem.id],
                selectedUrl: selectedItem.id,
            });
    }

    render() {
        return (
            <>
                <div className="top-menu">
                    <button
                        className="top-menu-responive-btn"
                        onClick={this.props.toggleResponsiveTopMenu}
                    >
                        <i className="icon-menu"></i>
                    </button>
                    <div className="top-menu-left">
                        {this.options.map(
                            (item) =>
                                !item.isHidden && (
                                    <React.Fragment key={item.id}>
                                        {item.href && (
                                            <a
                                                href={item.href}
                                                className={`top-menu-left-item ${
                                                    this.state.defaultSelected.includes(item.id)
                                                        ? 'active'
                                                        : ''
                                                }`}
                                            >
                                                {item.title}
                                            </a>
                                        )}
                                        {item.collapsTargetId && (
                                            <div className="top-menu-left-item ">
                                                <div
                                                    className={`top-menu-left-item-title with-arrow  ${
                                                        this.state.selectedIds?.includes(item.id)
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                >
                                                    {item.title}
                                                </div>
                                                <div className="top-menu-left-item-dropdown">
                                                    {item.children.map((child) => (
                                                        <React.Fragment key={child.id}>
                                                            <div
                                                                className={`top-menu-child
                                                        ${
                                                            this.state.selectedIds?.includes(
                                                                child.id,
                                                            )
                                                                ? 'active'
                                                                : ''
                                                        }
                                                        `}
                                                                key={child.id}
                                                            >
                                                                {child.href && (
                                                                    <a
                                                                        href={child.href}
                                                                        style={{ width: '100%' }}
                                                                    >
                                                                        {child.icon && (
                                                                            <i
                                                                                className={
                                                                                    child.icon
                                                                                }
                                                                            ></i>
                                                                        )}
                                                                        {child.title}
                                                                    </a>
                                                                )}
                                                                {child.collapsTargetId && (
                                                                    <>
                                                                        <div
                                                                            className="w-100 with-arrow"
                                                                            style={{
                                                                                width: '100%',
                                                                            }}
                                                                        >
                                                                            {child.icon && (
                                                                                <i
                                                                                    className={
                                                                                        child.icon
                                                                                    }
                                                                                ></i>
                                                                            )}
                                                                            {child.title}
                                                                        </div>
                                                                        <div className="top-menu-left-item-child-dropdown">
                                                                            {child.children.map(
                                                                                (state) => (
                                                                                    <div
                                                                                        key={
                                                                                            state.id
                                                                                        }
                                                                                        className={`top-menu-child
                                                                                ${
                                                                                    this.state.selectedIds?.includes(
                                                                                        state.id,
                                                                                    )
                                                                                        ? 'active'
                                                                                        : ''
                                                                                }
                                                                                `}
                                                                                    >
                                                                                        <a
                                                                                            href={
                                                                                                state.href
                                                                                            }
                                                                                            style={{
                                                                                                width: '100%',
                                                                                            }}
                                                                                        >
                                                                                            {state.icon && (
                                                                                                <i
                                                                                                    className={
                                                                                                        state.icon
                                                                                                    }
                                                                                                ></i>
                                                                                            )}
                                                                                            {
                                                                                                state.title
                                                                                            }
                                                                                        </a>
                                                                                    </div>
                                                                                ),
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                ),
                        )}
                    </div>
                    <div className="top-menu-right">
                        <button
                            className="btn-icon"
                            onClick={() => this.props.updateStyle('menu-version')}
                        >
                            <i className="icon-u_left-arrow-to-left-path2" />
                        </button>
                    </div>
                </div>
            </>
        );
    }
}

export default TopMenu;
